<template>
	<div style="font-size: 14px;">
		<div class="gongneng_box">
			<div style="display: flex;align-items: center;">
				<div 
					v-if="!showHeightSearch" 
					style="display: flex;align-items: center;">
					<el-select 
						v-model="formItem.field" 
						placeholder="请选择" 
						@change="fieldChange(formItem)">
						<el-option 
							v-for="item in options" 
							:key="item.field" 
							:label="item.name"
							:value="item.field">
						</el-option>
					</el-select>
					
					<!-- 条件值 -->
					<el-col 
						style="margin-left: 10px;" 
						:span="formItem.form_type === 'datetime' || formItem.form_type === 'date' ? 13 : 8">
						<el-select 
							v-if="formItem.form_type === 'select'" 
							v-model="formItem.value"
							clearable
							placeholder="请选择筛选条件">
							<el-option 
								v-for="item in formItem.setting" 
								:key="item" 
								:label="item" 
								:value="item" />
						</el-select>
						<div 
							style="width: 470px;" 
							v-else-if="formItem.form_type === 'date' || formItem.form_type === 'datetime'">
							<el-date-picker
								v-model="formItem.value"
								:value-format="formItem.form_type === 'date' ? 'yyyy-MM-dd' : 'yyyy-MM-dd HH:mm:ss'"
								:type="formItem.form_type === 'date' ? 'daterange' : 'datetimerange'"
								style="padding: 0px 10px;" 
								range-separator="-" 
								start-placeholder="开始日期"
								end-placeholder="结束日期" />
						</div>
						<div 
							style="width: 300px;" 
							v-else-if="formItem.form_type === 'user' || formItem.form_type === 'user-multiple'">
							<xh-user-cell
								:item="formItem" 
								@value-change="arrayValueChange" />
						</div>
						<el-input 
							v-else 
							v-model="formItem.value" 
							placeholder="请输入筛选条件" />
					</el-col>	
					<!-- 搜索 -->
					<el-button 
						style="margin-left: 15px; color: #fff; background-color: #f36b6b;"
						@click="onSearch()">搜索</el-button>
				</div>
			</div>
			<div style="display: flex;align-items: center;">
				<div v-if="crmType == 'lawcase' && !savetype">
					<el-popover
						placement="left"
						v-model="visible">
						<p style="line-height: 20px;">
							请选择案件类型
						</p>
						<div style="text-align: right;margin-top: 15px;">
							<el-button 
								size="mini" 
								@click="clickBtn('zixun')">非诉咨询</el-button>
							<el-button 
								size="mini" 
								@click="clickBtn('fuwu')">非诉服务</el-button>
							<el-button
								size="mini" 
								@click="clickBtn('susong')">诉讼案件</el-button>
							<el-button
								size="mini" 
								@click="clickBtn('xingshi')">刑事案件</el-button>
						</div>
						<el-button
							type="primary" 
							size="mini"  
							slot="reference"
							icon="el-icon-edit" >{{title}}</el-button>
					</el-popover>
				</div>
				<div v-else-if="crmType == 'customer' || crmType == 'contract'">
					<el-button
						v-if="canSave"
						icon="el-icon-edit" 
						class="buttomc"
						 @click="clickBtn(crmType)">{{title}}</el-button>
				</div>
				<div v-else>
					<el-button
						v-if="canSave"
						icon="el-icon-edit" 
						class="buttomc"
						 @click="clickBtn(crmType)">{{title}}</el-button>
				</div>
				<!-- 操作 -->
				<el-dropdown
					trigger="click"
					@command="handleTypeDrop">
					<el-button icon="el-icon-arrow-down" class="buttomc">批量操作</el-button>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item
							v-for="(item, index) in moreTypes"
							:key="index"
							:command="item.type">{{ item.name }}</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				<el-button 
					icon="el-icon-search"
					plain 
					style="margin-left: 15px;border: 1px solid #f36b6b;color: #f36b6b; "
					@click="heightSearch">高级搜索</el-button>
			</div>
		</div>
		<!-- 高级搜索选项 -->
		<div v-if="showHeightSearch" style="margin-top: 0px;">
			<el-row style="padding:20px">
				<el-col 
					:span="12" 
					v-for="(formItem, index) in form"
					:key="formItem.field" 
					style="margin-top: 15px;font-size: 13px;">
					<div style="padding-bottom: 15px;">{{formItem.name}}</div>
					<el-select
						v-if="formItem.form_type === 'select'" 
						v-model="formItem.value"
						placeholder="请选择筛选条件"
						class="heightitem">
						<el-option 
							v-for="item in formItem.setting" 
							:key="item" 
							:label="item" 
							:value="item" />
					</el-select>
					<el-date-picker
						v-else-if="formItem.form_type === 'date' || formItem.form_type === 'datetime'"
						v-model="formItem.value"
						:value-format="formItem.form_type === 'date' ? 'yyyy-MM-dd' : 'yyyy-MM-dd HH:mm:ss'"
						:type="formItem.form_type === 'date' ? 'daterange' : 'datetimerange'"
						style="padding: 0px 10px;" 
						range-separator="-" 
						start-placeholder="开始日期"
						end-placeholder="结束日期" 
						class="heightitem"/>
					<xh-user-cell
						v-else-if="formItem.form_type === 'user' || formItem.form_type === 'user-multiple'"
						:item="formItem" 
						@value-change="arrayValueChanges($event,index)" 
						:width="300"/>
					<el-input 
						v-else 
						v-model="formItem.value" 
						placeholder="请输入筛选条件" 
						class="heightitem"/>
				</el-col>
				<el-col
					:span="24" >
					<!-- 搜索 -->
					<el-button 
						style="margin-top: 15px; color: #fff; background-color: #b5060d;"
						@click="onHeightSearch()">搜索</el-button>
					<!-- 重置 -->
					<el-button
						style="margin-top: 15px; color: #b5060d; border:1px solid #b5060d;"
						@click="onHeightSearchReset()">重置</el-button>
				</el-col>
			</el-row>
		</div>
		
		<!-- 导入 -->
		<c-r-m-import
			:show="showCRMImport"
			:crm-type="crmType"
			@listRefresh="listRefresh"
			@close="showCRMImport=false"/>
		
		<!-- 导出 -->
		<c-r-m-export
			:show="showCRMExport"
			:crm-type="crmType"
			:search="search"
			:scene_id="scene_id"
			:actiontype="exporttype"
			:filter-arr="filterArr"
			:export-params="exportParams"
			@close="showCRMExport=false"/>	
		
	</div>
</template>

<script>
	import { mapGetters } from 'vuex'
	import CRMExport from '../CRMExport'
	import CRMImport from '../CRMImport'
	import { filterIndexfields } from '@/api/setting/setting'
	import { XhUserCell } from '@/components/user'
	import {
		formatTimeToTimestamp,
		objDeepCopy
	} from '@/utils'
	
	export default {
		components: {
			CRMExport,
			CRMImport,
			XhUserCell
		},
		props: {
			// CRM类型
			crmType: {
			  type: String,
			  default: ''
			},
			searchtype: {
			  type: [String,Number],
			  default: ''
			},
			actiontype: {
			  type: [String,Number],
			  default: ''
			},
			// 搜索条件
			search: {
			  type: String,
			  default: ''
			},
			exporttype: {
			  type: [String,Number],
			  default: ''
			},
			scene_id: {
			  type: [Number, String],
			  default: ''
			},
			filterArr: {
			  type: Array,
			  default: () => {
			    return []
			  }
			},
			savetype:{
			  type: Boolean,
			  default: false
			},
		},
		watch: {
			showHeightSearch: {
				handler(val) {
					if (!val) {
						if (this.form.length == 0) {
							this.form = []
						}
					}
				},
				deep: true,
				immediate: true
			}
		},
		
		data() {
			return {
				// 搜索
				form: [],
				formItem:{
					field: '',
					name: '',
					form_type: '',
					value: ''
				},
				options: [],
				value: '',
				showHeightSearch:false,
				
				
				/** 更多操作 */
				moreTypes: [],
				
				/** 创建的相关信息*/
				createActionInfo: { type: 'save' },
				createCRMType: '',
				isCreate: false, 
				visible:false,
				// 导出选中参数
				exportParams: {},
				// 导出
				showCRMExport: false,
				// 导入
				showCRMImport: false,
			}
		},
		mounted() {
			// 更多操作
			// if (this.allAuth[this.crmType] && this.allAuth[this.crmType].excelimport) {
			// 	this.moreTypes.push({ type: 'enter', name: '导入' })
			// }
			if (this.allAuth[this.crmType] && this.allAuth[this.crmType].excelexport) {
				this.moreTypes.push({ type: 'out', name: '导出' })
			}
			this.getFieldList()
			
		},
		computed: {
			...mapGetters(['allAuth']),
			canSave() {
				if(this.crmType == "customer" || this.crmType == "lawcase" || this.crmType == "contract") {
					return this.allAuth[this.crmType].save
				}else{
					return false
				}
				
			},
			title() {
				if(this.crmType == "customer") {
					return '新建线索'
				}else if(this.crmType == "lawcase" && this.savetype == false){
					return '新建案件'
				}else if(this.crmType == "contract"){
					if(this.actiontype == 10){
						return '新建顾问'
					}else{
						return '新建'
					}
					
				}else{
					return "新建"
				}
			}
		},
		methods: {
			
			// 点击按钮
			clickBtn(type) {
				this.$emit("save-handle",type)
			},
			
			// 更多操作
			handleTypeDrop(command, params = {}) {
				if (command == 'out') {
					// 导出
					let paramsData = {}
					if (params.__export) {
						paramsData = params
						delete paramsData.__export
					} else {
						paramsData = {}
					}
					this.exportParams = paramsData
					this.showCRMExport = true
				} else if (command == 'enter') {
					// 导入
					this.showCRMImport = true
				}
			},
			
			
			// 关闭新建弹窗
			hideView() {
				this.isCreate = false
				this.$emit('hide-view')
			},
			
			// 搜索板块
			/**
			 * 用户
			 */
			arrayValueChange(data) {
				if(data.value.length > 0){
					this.formItem["value"]  = data.value
				}else{
					this.formItem["value"]  = ''
				}
				
			},
			
			arrayValueChanges(data,index) {
				if(data.value.length > 0){
					this.form[index]["value"]  = data.value
				}else{
					this.form[index]["value"] = ''
				}
			},
			
			getFieldList()  {
				filterIndexfields({
						types: 'crm_' + this.crmType,
						actiontype:this.searchtype
					})
					.then(res => {
						this.form = res.data
						this.options = res.data
					})
					.catch(() => {})
			},
			fieldChange(formItem) {
				const obj = this.options.find(item => {
					return item.field === formItem.field
				})
				if (obj) {
					formItem.form_type = obj.form_type
					formItem.name = obj.name
					if (formItem.form_type == 'select') {
						formItem.setting = obj.setting || []
						formItem.value = ''
					} else if (
						formItem.form_type === 'date' ||
						formItem.form_type === 'datetime' ||
						formItem.form_type === 'user'||
						formItem.form_type === 'user-multiple'
					) {
						formItem.value = []
					}else{
						formItem.value = ''
					}
				}
				
			},
			
			// 搜索
			onSearch(){
				this.$emit("on-search",this.formItem)
			},
			
			// 高级搜索显示
			heightSearch(){
				this.showHeightSearch = !this.showHeightSearch
			},
			onHeightSearch(){
				this.$emit("on-height-search",this.form)
			},
			onHeightSearchReset(){
				this.form.map((formItem)=>{
					if(formItem.value != undefined){
						if (formItem.form_type == 'select') {
							formItem.value = ''
						} else if (
							formItem.form_type === 'date' ||
							formItem.form_type === 'datetime'
						) {
							formItem.value = []
						}else if (
							formItem.form_type === 'user'||
							formItem.form_type === 'user-multiple'
						) {
							formItem.value = []
							// 补充
							
						}else{
							formItem.value = ''
						}
					}
				})
				this.$emit("on-height-search",this.form)
			},
			
			listRefresh() {
				this.$emit('listRefresh')
			}
			
		},
	}
</script>

<style scoped>
	.buttomc{
		margin-left: 15px; 
		color: #fff; 
		background-color: #f36b6b;
	}
	.gongneng_box {
		margin-top: 10px;
		display: flex;
		justify-content: space-between;
		font-size: 14px;
	}
	.heightitem{
		width: 300px;
	}
</style>